var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDyeEmptyClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 86,
    fill: "none",
    viewBox: "0 0 40 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#868CA6",
    d: "M13.046 85.58c-.888 0-2.245-.325-2.993-.558-.749-.233-1.357-2.935-1.357-2.935-1.965-7.64-4.624-18.883-4.684-25.66C4 55.084 4.012 29 4.012 29H22.063v27.427c0 7-3.122 18.02-5.087 25.66 0 0-.608 2.702-1.357 2.935-.748.233-2.105.559-2.993.559"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C3D2",
    d: "M12.992 84.642c-.795 0-2.012-.28-2.666-.513-.655-.186-1.217-2.655-1.217-2.655-1.777-6.849-3.58-16.945-4.095-22.955V30.427H21.06s.28 24.924 0 28.092c-.514 6.01-2.735 16.06-4.513 22.908 0 0-.561 2.423-1.216 2.656-.655.186-1.871.512-2.666.512",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#868CA6",
    d: "M2.006 29h23.066v2H2.006z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M17.049 31h5.014v26.51c0 2.945-2.006 12.272-2.006 12.272s-3.792 14.513-4.011 14.727c-.22.215-3.009.491-3.009.491l4.012-27.49V31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#868CA6",
    d: "M0 26h26.074v2H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#577898",
    d: "M5.014 28H21.06v1H5.014z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#868CA6",
    fillRule: "evenodd",
    d: "M28.755 27.123c.25.422.328.903.328 1.377s-.077.955-.328 1.377c-.265.447-.658.716-1.075.872-.39.146-.822.2-1.23.226-.407.025-.872.025-1.356.025h-.023v-2c.512 0 .916 0 1.254-.021.344-.022.54-.061.65-.103a.406.406 0 0 0 .058-.026 1.351 1.351 0 0 0 .044-.35c0-.134-.011-.224-.024-.282a.422.422 0 0 0-.02-.068.406.406 0 0 0-.057-.026c-.111-.042-.307-.081-.65-.103a21.656 21.656 0 0 0-1.255-.02v-2h.023c.484-.001.949-.001 1.356.024.408.026.84.08 1.23.226.417.156.81.426 1.075.872z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDyeEmptyClose);
export default __webpack_public_path__ + "static/media/RedDye-empty-close.f48035e3c1e75dadda5ec0ed52b049e7.svg";
export { ForwardRef as ReactComponent };